import { render, staticRenderFns } from "./product-suppliers-dialog.vue?vue&type=template&id=9df7e942&"
import script from "./product-suppliers-dialog.vue?vue&type=script&lang=js&"
export * from "./product-suppliers-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports